var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "auto",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 8.625C9.76172 8.625 11.6875 6.73242 11.6875 4.375C11.6875 2.05078 9.76172 0.125 7.4375 0.125C5.08008 0.125 3.1875 2.05078 3.1875 4.375C3.1875 6.73242 5.08008 8.625 7.4375 8.625ZM10.3926 9.6875H9.82812C9.09766 10.0527 8.30078 10.2188 7.4375 10.2188C6.57422 10.2188 5.74414 10.0527 5.01367 9.6875H4.44922C1.99219 9.6875 0 11.7129 0 14.1699V15.5312C0 16.4277 0.697266 17.125 1.59375 17.125H13.2812C14.1445 17.125 14.875 16.4277 14.875 15.5312V14.1699C14.875 11.7129 12.8496 9.6875 10.3926 9.6875Z",
    fill: "auto"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.e622cbd1b12c4912ca5aaef104664740.svg";
export { ForwardRef as ReactComponent };